import { DatePipe } from "@angular/common";

export class DateFormat {
    private static datePipe = new DatePipe("pt-BR");

    static getFormattedDate(date: Date): string {
      return this.datePipe.transform(date, "yyyy-MM-dd") as string;
    }

    static getMonth(date: Date, format: string = "MM"): string {
      return this.datePipe.transform(date, format) as string;
    }

    static getYear(date: Date, format: string = "yyyy"): string {
      return this.datePipe.transform(date, format) as string;
    }

    static getDay(date: Date, format: string = "dd"): string {
      return this.datePipe.transform(date, format) as string;
    }

    static splitDate(date: Date): string[] {
        return [this.getDay(date), this.getMonth(date), this.getYear(date)];
    }

    static getFormattedRangeDate(start: Date, end: Date): {start: string, end: string} {
        return {start: this.getFormattedDate(start), end: this.getFormattedDate(end)}
    }

    static getRangeMonth(month: number): {start: string, end: string} {
        let date = new Date();
        date.setMonth(month - 1);
        date.setDate(1);
        let start = new Date(date.getFullYear(), date.getMonth(), 1);
        let end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return this.getFormattedRangeDate(start, end);
    }

    static getRangeDay(start: number, end: number, month?: number): {start: string, end: string} {
        let date = new Date();
        date.setDate(start);
        let startDay = new Date(date.getFullYear(), month ?? date.getMonth(), date.getDate());
        date.setDate(end);
        let endDay = new Date(date.getFullYear(), month ?? date.getMonth(), date.getDate());
        return this.getFormattedRangeDate(startDay, endDay);
    }

}
